import { apiURL } from './constants';
import axios from 'axios';

const baseURL = `${apiURL}/api/shipping_company`;

function getAuthHeaders() {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
}

function throwIfErrorResponse(response) {
  if (response && typeof response.status === 'number' && response.status >= 400) {
    const err = new Error(`HTTP ${response.status}`);
    err.response = response;
    throw err;
  }
  return response;
}

/**
 * Paginated list of ShippingCompany rows.
 * Permission: shipping_companies_list
 * @param {Object} params - page, page_size, pagination, search, active, ordering (id|name|code|active)
 */
export async function listShippingCompanies(params = {}) {
  getAuthHeaders();
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });
  const qs = searchParams.toString();
  const url = `${baseURL}/${qs ? `?${qs}` : ''}`;
  const response = await axios.get(url, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).catch((error) => {
    console.error('listShippingCompanies error:', error);
    throw error;
  });
  return throwIfErrorResponse(response);
}

/** Permission: shipping_companies_view */
export async function getShippingCompany(id) {
  getAuthHeaders();
  const response = await axios.get(`${baseURL}/${id}/`, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).catch((error) => {
    console.error('getShippingCompany error:', error);
    throw error;
  });
  return throwIfErrorResponse(response);
}

/** Permission: shipping_companies_create */
export async function createShippingCompany(body) {
  getAuthHeaders();
  const response = await axios.post(`${baseURL}/`, body, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).catch((error) => {
    console.error('createShippingCompany error:', error);
    throw error;
  });
  return throwIfErrorResponse(response);
}

/** Permission: shipping_companies_update */
export async function updateShippingCompany(id, body, partial = true) {
  getAuthHeaders();
  const method = partial ? 'patch' : 'put';
  const response = await axios[method](`${baseURL}/${id}/`, body, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).catch((error) => {
    console.error('updateShippingCompany error:', error);
    throw error;
  });
  return throwIfErrorResponse(response);
}

/** Permission: shipping_companies_delete */
export async function deleteShippingCompany(id) {
  getAuthHeaders();
  const response = await axios.delete(`${baseURL}/${id}/`, {
    withCredentials: true,
  }).catch((error) => {
    console.error('deleteShippingCompany error:', error);
    throw error;
  });
  return throwIfErrorResponse(response);
}
